export var Icons;
(function (Icons) {
	Icons["Add"] = "add";
	Icons["AddCircled"] = "add_circled";
	Icons["AddColumnLeft"] = "add_column_left";
	Icons["AddColumnRight"] = "add_column_right";
	Icons["AddRowDown"] = "add_row_down";
	Icons["AddRowUp"] = "add_row_up";
	Icons["AddSquare"] = "add_square";
	Icons["AiData"] = "ai_data";
	Icons["Alarm"] = "alarm";
	Icons["AlignCenter"] = "align_center";
	Icons["AlignJustify"] = "align_justify";
	Icons["AlignLeft"] = "align_left";
	Icons["AlignRight"] = "align_right";
	Icons["Angular"] = "angular";
	Icons["Antenna"] = "antenna";
	Icons["AntennaOff"] = "antenna_off";
	Icons["AntennaSignal"] = "antenna_signal";
	Icons["AppleImac"] = "apple_imac";
	Icons["Archive"] = "archive";
	Icons["ArrowDown"] = "arrow_down";
	Icons["ArrowDropDown"] = "arrow_drop_down";
	Icons["ArrowDropUp"] = "arrow_drop_up";
	Icons["ArrowLeft"] = "arrow_left";
	Icons["ArrowRight"] = "arrow_right";
	Icons["ArrowSeparate"] = "arrow_separate";
	Icons["ArrowSeparateVertical"] = "arrow_separate_vertical";
	Icons["ArrowUnion"] = "arrow_union";
	Icons["ArrowUnionVertical"] = "arrow_union_vertical";
	Icons["ArrowUp"] = "arrow_up";
	Icons["Attachment"] = "attachment";
	Icons["Autopay"] = "autopay";
	Icons["Backspace"] = "backspace";
	Icons["Badge"] = "badge";
	Icons["Block"] = "block";
	Icons["Bluetooth"] = "bluetooth";
	Icons["Boat"] = "boat";
	Icons["Bold"] = "bold";
	Icons["Book"] = "book";
	Icons["BookmarkEmpty"] = "bookmark_empty";
	Icons["Bug"] = "bug";
	Icons["Building"] = "building";
	Icons["Cable"] = "cable";
	Icons["CahsRegister"] = "cahs-register";
	Icons["Cake"] = "cake";
	Icons["Calendar"] = "calendar";
	Icons["Calltracking"] = "calltracking";
	Icons["Camera"] = "camera";
	Icons["Cancel"] = "cancel";
	Icons["Capability"] = "capability";
	Icons["Car"] = "car";
	Icons["Cart"] = "cart";
	Icons["Catalog"] = "catalog";
	Icons["Cell"] = "cell";
	Icons["Certificate"] = "certificate";
	Icons["Change"] = "change";
	Icons["ChangeUsers"] = "change_users";
	Icons["Chat"] = "chat";
	Icons["ChatFull"] = "chat_full";
	Icons["Check"] = "check";
	Icons["CheckCircled"] = "check_circled";
	Icons["Checkbox"] = "checkbox";
	Icons["City"] = "city";
	Icons["Clock"] = "clock";
	Icons["Close"] = "close";
	Icons["Cloud"] = "cloud";
	Icons["CloudBook"] = "cloud_book";
	Icons["CloudCheck"] = "cloud_check";
	Icons["CloudDesync"] = "cloud_desync";
	Icons["CloudDownload"] = "cloud_download";
	Icons["CloudError"] = "cloud_error";
	Icons["CloudSync"] = "cloud_sync";
	Icons["CloudUpload"] = "cloud_upload";
	Icons["Code"] = "code";
	Icons["Collapse"] = "collapse";
	Icons["CommutationTraffic"] = "commutation_traffic";
	Icons["Computer"] = "computer";
	Icons["Connect"] = "connect";
	Icons["Copy"] = "copy";
	Icons["CornerBottomLeft"] = "corner_bottom_left";
	Icons["CornerBottomRight"] = "corner_bottom_right";
	Icons["CornerTopLeft"] = "corner_top_left";
	Icons["CornerTopRight"] = "corner_top_right";
	Icons["Cpu"] = "cpu";
	Icons["CpuWarning"] = "cpu_warning";
	Icons["CreditCard"] = "credit_card";
	Icons["CreditCardOff"] = "credit_card_off";
	Icons["Cycle"] = "cycle";
	Icons["DashboardDots"] = "dashboard_dots";
	Icons["DataTransferBoth"] = "data_transfer_both";
	Icons["DataTransferCheck"] = "data_transfer_check";
	Icons["DataTransferDown"] = "data_transfer_down";
	Icons["DataTransferUp"] = "data_transfer_up";
	Icons["DataTransferWarning"] = "data_transfer_warning";
	Icons["Database"] = "database";
	Icons["DatabaseBackup"] = "database_backup";
	Icons["DatabaseCheck"] = "database_check";
	Icons["DatabaseError"] = "database_error";
	Icons["DatabaseExport"] = "database_export";
	Icons["DatabaseRestore"] = "database_restore";
	Icons["DatabaseSearch"] = "database_search";
	Icons["DatabaseSettings"] = "database_settings";
	Icons["DatabaseStats"] = "database_stats";
	Icons["DatabaseWarning"] = "database_warning";
	Icons["Delete"] = "delete";
	Icons["Delivery"] = "delivery";
	Icons["Dialpad"] = "dialpad";
	Icons["Disconnect"] = "disconnect";
	Icons["Display4K"] = "display_4k";
	Icons["Dollar"] = "dollar";
	Icons["Domain"] = "domain";
	Icons["Dot"] = "dot";
	Icons["DoubleCheck"] = "double_check";
	Icons["Download"] = "download";
	Icons["DragIndicator"] = "drag_indicator";
	Icons["Eco"] = "eco";
	Icons["Edit"] = "edit";
	Icons["ElectronicsChip"] = "electronics_chip";
	Icons["Emoji"] = "emoji";
	Icons["EmojiHappy"] = "emoji_happy";
	Icons["EmojiNeutral"] = "emoji_neutral";
	Icons["EmojiSad"] = "emoji_sad";
	Icons["EmojiUpset"] = "emoji_upset";
	Icons["Energetics"] = "energetics";
	Icons["Equals"] = "equals";
	Icons["Euro"] = "euro";
	Icons["Expand"] = "expand";
	Icons["Eye"] = "eye";
	Icons["EyeOff"] = "eye_off";
	Icons["FaceId"] = "face_id";
	Icons["Factory"] = "factory";
	Icons["FastArrowDown"] = "fast_arrow_down";
	Icons["FastArrowLeft"] = "fast_arrow_left";
	Icons["FastArrowRight"] = "fast_arrow_right";
	Icons["FastArrowTop"] = "fast_arrow_top";
	Icons["FeatherPen"] = "feather_pen";
	Icons["Filter"] = "filter";
	Icons["FingerprintScan"] = "fingerprint_scan";
	Icons["Flag"] = "flag";
	Icons["Flash"] = "flash";
	Icons["Folder"] = "folder";
	Icons["FolderAdd"] = "folder_add";
	Icons["FolderAlert"] = "folder_alert";
	Icons["FolderRemove"] = "folder_remove";
	Icons["Forward"] = "forward";
	Icons["Gift"] = "gift";
	Icons["Gitlab"] = "gitlab";
	Icons["GraphDown"] = "graph_down";
	Icons["GraphUp"] = "graph_up";
	Icons["Grid"] = "grid";
	Icons["GridAdd"] = "grid_add";
	Icons["GridMinus"] = "grid_minus";
	Icons["GridRemove"] = "grid_remove";
	Icons["Group"] = "group";
	Icons["GroupElements"] = "group_elements";
	Icons["HalfMoon"] = "half_moon";
	Icons["Handshake"] = "handshake";
	Icons["HardDrive"] = "hard_drive";
	Icons["Headset"] = "headset";
	Icons["HeadsetHelp"] = "headset_help";
	Icons["HeadsetIssue"] = "headset_issue";
	Icons["Heart"] = "heart";
	Icons["HeartFull"] = "heart_full";
	Icons["Help"] = "help";
	Icons["Home"] = "home";
	Icons["Hourglass"] = "hourglass";
	Icons["Iframe"] = "iframe";
	Icons["Image"] = "image";
	Icons["Import"] = "import";
	Icons["IncomeDone"] = "income_done";
	Icons["IncomeError"] = "income_error";
	Icons["Infinity"] = "infinity";
	Icons["Info"] = "info";
	Icons["InfoCircled"] = "info_circled";
	Icons["Integration"] = "integration";
	Icons["Iot"] = "iot";
	Icons["Italic"] = "italic";
	Icons["Journal"] = "journal";
	Icons["Label"] = "label";
	Icons["Language"] = "language";
	Icons["Laptop"] = "laptop";
	Icons["LaptopOff"] = "laptop_off";
	Icons["Layout"] = "layout";
	Icons["LayoutFull"] = "layout_full";
	Icons["LayoutLeft"] = "layout_left";
	Icons["LayoutRight"] = "layout_right";
	Icons["Lifebelt"] = "lifebelt";
	Icons["LineSpace"] = "line_space";
	Icons["Link"] = "link";
	Icons["List"] = "list";
	Icons["ListNumbers"] = "list_numbers";
	Icons["Lock"] = "lock";
	Icons["LockOff"] = "lock_off";
	Icons["LogIn"] = "log_in";
	Icons["LogOut"] = "log_out";
	Icons["Logistic"] = "logistic";
	Icons["Magic"] = "magic";
	Icons["Mail"] = "mail";
	Icons["MailOpened"] = "mail_opened";
	Icons["Map"] = "map";
	Icons["Megaphone"] = "megaphone";
	Icons["Menu"] = "menu";
	Icons["MenuOpen"] = "menu_open";
	Icons["Merge"] = "merge";
	Icons["Message"] = "message";
	Icons["MessageAlert"] = "message_alert";
	Icons["MessageText"] = "message_text";
	Icons["Mic"] = "mic";
	Icons["MicMute"] = "mic_mute";
	Icons["Moon"] = "moon";
	Icons["MoreHoriz"] = "more_horiz";
	Icons["MoreVert"] = "more_vert";
	Icons["Mouse"] = "mouse";
	Icons["MouseButtonLeft"] = "mouse_button_left";
	Icons["MouseButtonRight"] = "mouse_button_right";
	Icons["MouseScrollWheel"] = "mouse_scroll_wheel";
	Icons["MultiBubble"] = "multi_bubble";
	Icons["Multichanndel"] = "multichanndel";
	Icons["Music"] = "music";
	Icons["Nature"] = "nature";
	Icons["NavArrowDown"] = "nav_arrow_down";
	Icons["NavArrowLeft"] = "nav_arrow_left";
	Icons["NavArrowRight"] = "nav_arrow_right";
	Icons["NavArrowUp"] = "nav_arrow_up";
	Icons["Network"] = "network";
	Icons["NetworkAlt"] = "network_alt";
	Icons["NetworkLeft"] = "network_left";
	Icons["NetworkRight"] = "network_right";
	Icons["Notes"] = "notes";
	Icons["Notification"] = "notification";
	Icons["NotificationNew"] = "notification_new";
	Icons["NotificationOff"] = "notification_off";
	Icons["Ofd"] = "ofd";
	Icons["OpenInBrowser"] = "open_in_browser";
	Icons["OpenInWindow"] = "open_in_window";
	Icons["OutcomeDone"] = "outcome_done";
	Icons["OutcomeError"] = "outcome_error";
	Icons["Page"] = "page";
	Icons["PageAdd"] = "page_add";
	Icons["PageEmpty"] = "page_empty";
	Icons["PageRemove"] = "page_remove";
	Icons["PageSearch"] = "page_search";
	Icons["PageStar"] = "page_star";
	Icons["PagesMultiple"] = "pages_multiple";
	Icons["PagesMultipleAdd"] = "pages_multiple_add";
	Icons["PagesMultipleDelete"] = "pages_multiple_delete";
	Icons["PagesMultipleEmpty"] = "pages_multiple_empty";
	Icons["PagesMultipleRemove"] = "pages_multiple_remove";
	Icons["Palette"] = "palette";
	Icons["Passport"] = "passport";
	Icons["Pause"] = "pause";
	Icons["Percentage"] = "percentage";
	Icons["Phone"] = "phone";
	Icons["PhoneAdd"] = "phone_add";
	Icons["PhoneDelete"] = "phone_delete";
	Icons["PhoneDisabled"] = "phone_disabled";
	Icons["PhoneIncome"] = "phone_income";
	Icons["PhoneOutcome"] = "phone_outcome";
	Icons["PhonePaused"] = "phone_paused";
	Icons["PhoneRemove"] = "phone_remove";
	Icons["Pin"] = "pin";
	Icons["PinAdd"] = "pin_add";
	Icons["Pipeline"] = "pipeline";
	Icons["Plane"] = "plane";
	Icons["Play"] = "play";
	Icons["PlaylistPlay"] = "playlist_play";
	Icons["Position"] = "position";
	Icons["PowerOff"] = "power_off";
	Icons["Printer"] = "printer";
	Icons["ProfileCircled"] = "profile_circled";
	Icons["Puzzle"] = "puzzle";
	Icons["Question"] = "question";
	Icons["QuestionCircled"] = "question_circled";
	Icons["Radar"] = "radar";
	Icons["Redo"] = "redo";
	Icons["Refresh"] = "refresh";
	Icons["RefreshDouble"] = "refresh_double";
	Icons["Remove"] = "remove";
	Icons["RemoveSquare"] = "remove_square";
	Icons["ReportColumns"] = "report_columns";
	Icons["Reports"] = "reports";
	Icons["Rewind"] = "rewind";
	Icons["Robot"] = "robot";
	Icons["Ruble"] = "ruble";
	Icons["RulerPencil"] = "ruler_pencil";
	Icons["Safebox"] = "safebox";
	Icons["SalesFunnel"] = "sales_funnel";
	Icons["Satellite"] = "satellite";
	Icons["Save"] = "save";
	Icons["Scanning"] = "scanning";
	Icons["Search"] = "search";
	Icons["Security"] = "security";
	Icons["Segment"] = "segment";
	Icons["Send"] = "send";
	Icons["Server"] = "server";
	Icons["ServerConnection"] = "server_connection";
	Icons["Services"] = "services";
	Icons["ServicesFull"] = "services_full";
	Icons["SettingMenu"] = "setting_menu";
	Icons["Settings"] = "settings";
	Icons["ShareAndroid"] = "share_android";
	Icons["ShareIos"] = "share_ios";
	Icons["Shop"] = "shop";
	Icons["ShoppingBag"] = "shopping_bag";
	Icons["ShoppingBagFull"] = "shopping_bag_full";
	Icons["Signature"] = "signature";
	Icons["SkipNext"] = "skip_next";
	Icons["SkipPrev"] = "skip_prev";
	Icons["Smartphone"] = "smartphone";
	Icons["Sms"] = "sms";
	Icons["Software"] = "software";
	Icons["SortDown"] = "sort_down";
	Icons["SortUp"] = "sort_up";
	Icons["SoundHigh"] = "sound_high";
	Icons["SoundLow"] = "sound_low";
	Icons["SoundMin"] = "sound_min";
	Icons["SoundOff"] = "sound_off";
	Icons["Split"] = "split";
	Icons["Star"] = "star";
	Icons["StarFull"] = "star_full";
	Icons["StatDown"] = "stat_down";
	Icons["StatSquareDown"] = "stat_square_down";
	Icons["StatSquareUp"] = "stat_square_up";
	Icons["StatUp"] = "stat_up";
	Icons["Suitcase"] = "suitcase";
	Icons["Sun"] = "sun";
	Icons["Table"] = "table";
	Icons["TableColumns"] = "table_columns";
	Icons["TableRows"] = "table_rows";
	Icons["Tasks"] = "tasks";
	Icons["Terminal"] = "terminal";
	Icons["Text"] = "text";
	Icons["TextSize"] = "text_size";
	Icons["Thermometer"] = "thermometer";
	Icons["Timer"] = "timer";
	Icons["TimerOff"] = "timer_off";
	Icons["Tune"] = "tune";
	Icons["Tv"] = "tv";
	Icons["TvModern"] = "tv_modern";
	Icons["Underline"] = "underline";
	Icons["Undo"] = "undo";
	Icons["UnlimitedSms"] = "unlimited_sms";
	Icons["Upload"] = "upload";
	Icons["Usb"] = "usb";
	Icons["User"] = "user";
	Icons["UserAdd"] = "user_add";
	Icons["UserRemove"] = "user_remove";
	Icons["UserSearch"] = "user_search";
	Icons["UserVerified"] = "user_verified";
	Icons["Variables"] = "variables";
	Icons["VideoCamera"] = "video_camera";
	Icons["VideoCameraOff"] = "video_camera_off";
	Icons["ViewColumns2"] = "view_columns_2";
	Icons["ViewColumns3"] = "view_columns_3";
	Icons["ViewStructureDown"] = "view_structure_down";
	Icons["ViewStructureUp"] = "view_structure_up";
	Icons["Voice"] = "voice";
	Icons["VoiceError"] = "voice_error";
	Icons["VoiceOk"] = "voice_ok";
	Icons["Vue"] = "vue";
	Icons["Wallet"] = "wallet";
	Icons["WalletFull"] = "wallet_full";
	Icons["WarningCircled"] = "warning_circled";
	Icons["WarningTriangle"] = "warning_triangle";
	Icons["Wifi"] = "wifi";
	Icons["WifiIssue"] = "wifi_issue";
	Icons["WifiOff"] = "wifi_off";
	Icons["WifiSignalNone"] = "wifi_signal_none";
	Icons["WrapText"] = "wrap_text";
	Icons["Wristwatch"] = "wristwatch";
	Icons["ZoomIn"] = "zoom_in";
	Icons["ZoomOut"] = "zoom_out"
})(Icons || (Icons = {}));